export const FETCH_FOOTER_INFO = "FETCH_FOOTER_INFO"
export const FETCH_FOOTER_INFO_SUCCESS = "FETCH_FOOTER_INFO_SUCCESS"

  